<div class="icn-radio-button" *ngIf="!!rule">
  <input
    type="radio"
    id="d"
    name="radiogroup1"
    [value]="false"
    [(ngModel)]="rule.limitRule"
  />
  <label for="d">Run Rule Forever</label><br />

  <input
    type="radio"
    id="e"
    name="radiogroup1"
    [value]="true"
    [(ngModel)]="rule.limitRule"
  />
  <label for="e">Set Date and Time</label><br />
</div>

<div class="limit-options" *ngIf="!!rule && !!rule.limitRule">
  <div class="label">DATE RANGE:</div>
  <div class="controls">
    <div class="input-group">
      <label>Start Date:</label>
      <dateinput
        [current]="rule.limitRuleStartDate"
        (currentChange)="onStartDateChange($event)"
      ></dateinput>
    </div>
    <div class="input-group">
      <label>End Date:</label>
      <dateinput
        [current]="rule.limitRuleEndDate"
        (currentChange)="onEndDateChange($event)"
      ></dateinput>
    </div>
  </div>
</div>
<div class="limit-options" *ngIf="showTimeRangePickers()">
  <div class="label">TIME RANGE:</div>
  <div class="controls">
    <div class="input-group">
      <label>Start Time:</label>
      <!--<icn-hour-picker [hour] = "hourStart()" (hourChange)="onStartHourChange($event)"></icn-hour-picker>-->
      <icn-time-picker
        [timeInMinutes]="timeStart()"
        (timeInMinutesChange)="onStartTimeChange($event)"
      ></icn-time-picker>
    </div>
    <div class="input-group">
      <label>End Time:</label>

      <!--<icn-hour-picker [hour] = "hourEnd()" (hourChange)="onEndHourChange($event)"></icn-hour-picker>-->
      <icn-time-picker
        [timeInMinutes]="timeEnd()"
        (timeInMinutesChange)="onEndTimeChange($event)"
      ></icn-time-picker>
    </div>
  </div>
</div>
